/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='sw1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw1'">Sw1</vs-button>
          <vs-button :color="sel==='sw2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw2'">Sw2</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">802.1Q trunk — native VLAN 45, allow 15 &amp; 45</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/10</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2']" :key="'t1-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swkLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task1Items" :key="'t1-'+swk+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
              <p class="text-xs mt-1 ml-1" style="color:#6b7280">Verify: PC1 → <code>ping 10.15.15.20</code></p>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">LACP (802.3ad) — Port-Channel 15, active mode</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2']" :key="'t2-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swkLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task2Items" :key="'t2-'+swk+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [sw1Completion.saved,sw2Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2']" :key="'s-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swkLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk).saved)"></div>
                    <code class="text-base" :class="getComp(swk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='sw1'" key="sw1" id="sw1_terminal" :commands="sw1Commands" :prompt="sw1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="Sw1" />
          <vue-command v-show="sel==='sw2'" key="sw2" id="sw2_terminal" :commands="sw2Commands" :prompt="sw2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="Sw2" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist. Use "interface range e0/0 - 1" to configure both trunk ports at once.';

const mkCommands = (swk, vm) => ({
  help:            () => createStdout(HELP),
  enable:          () => vm.iosEnable(swk),
  configure:       (x) => vm.iosConfigure(swk, x),
  conf:            (x) => vm.iosConfigure(swk, x),
  interface:       (x) => vm.iosInterface(swk, x),
  int:             (x) => vm.iosInterface(swk, x),
  switchport:      (x) => vm.iosSwitchport(swk, x),
  'channel-group': (x) => vm.iosChannelGroup(swk, x),
  exit:            () => vm.iosExit(swk),
  end:             () => vm.iosEnd(swk),
  copy:            (x) => vm.iosCopy(swk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/Trunking_LACP_Sim.png',
      sel: 'sw1',
      totalScore: 0,

      sw1: { mode: 'exec', currentIf: null },
      sw2: { mode: 'exec', currentIf: null },

      // 7 keys per switch × 2 = 14 total
      sw1Completion: { rangeEntered: false, trunkEncap: false, trunkMode: false, trunkNative: false, trunkAllowed: false, channelGroup: false, saved: false },
      sw2Completion: { rangeEntered: false, trunkEncap: false, trunkMode: false, trunkNative: false, trunkAllowed: false, channelGroup: false, saved: false },

      sw1Commands: null,
      sw2Commands: null,

      task1Items: [
        { key: 'rangeEntered', label: 'interface range e0/0 - 1' },
        { key: 'trunkEncap',   label: 'switchport trunk encapsulation dot1q' },
        { key: 'trunkMode',    label: 'switchport mode trunk' },
        { key: 'trunkNative',  label: 'switchport trunk native vlan 45' },
        { key: 'trunkAllowed', label: 'switchport trunk allowed vlan 15,45' },
      ],
      task2Items: [
        { key: 'channelGroup', label: 'channel-group 15 mode active' },
      ],
    };
  },

  computed: {
    sw1Prompt() {
      const m = this.sw1.mode;
      if (m === 'config-if-range') return 'Sw1(config-if-range)#';
      if (m === 'config-if')       return 'Sw1(config-if)#';
      if (m === 'config')          return 'Sw1(config)#';
      return 'Sw1#';
    },
    sw2Prompt() {
      const m = this.sw2.mode;
      if (m === 'config-if-range') return 'Sw2(config-if-range)#';
      if (m === 'config-if')       return 'Sw2(config-if)#';
      if (m === 'config')          return 'Sw2(config)#';
      return 'Sw2#';
    },

    task1Progress() {
      const c1 = this.sw1Completion, c2 = this.sw2Completion;
      return [c1.rangeEntered, c1.trunkEncap, c1.trunkMode, c1.trunkNative, c1.trunkAllowed,
              c2.rangeEntered, c2.trunkEncap, c2.trunkMode, c2.trunkNative, c2.trunkAllowed].filter(Boolean).length;
    },
    task1Done() { return this.task1Progress === 10; },

    task2Progress() {
      return [this.sw1Completion.channelGroup, this.sw2Completion.channelGroup].filter(Boolean).length;
    },
    task2Done() { return this.task2Progress === 2; },

    saveDone() { return this.sw1Completion.saved && this.sw2Completion.saved; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.sw1Commands = mkCommands('sw1', this);
    this.sw2Commands = mkCommands('sw2', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },
    swkLabel(k) { return k === 'sw1' ? 'Sw1' : 'Sw2'; },

    dot(val) {
      return { width:'8px', height:'8px', background: val?'#28C76F':'transparent', border:'2px solid '+(val?'#28C76F':'#6b7280') };
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    normalizeIf(ifStr) {
      return (ifStr || '').toLowerCase()
        .replace(/^gigabitethernet/, '')
        .replace(/^fastethernet/, '')
        .replace(/^ethernet/, '')
        .replace(/^fa(?=\d)/, '')
        .replace(/^e(?=\d)/, '')
        .replace(/^g(?=\d)/, '')
        .trim();
    },

    updateScore() {
      let score = 0;
      [this.sw1Completion, this.sw2Completion].forEach(c => Object.values(c).forEach(v => { if (v) score++; }));
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 14) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(swk) { this[swk].mode = 'exec'; return createStdout(''); },

    iosConfigure(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        s.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(swk) {
      const s = this[swk];
      if (s.mode === 'config-if' || s.mode === 'config-if-range') { s.mode = 'config'; s.currentIf = null; }
      else if (s.mode === 'config') { s.mode = 'exec'; }
      return createStdout('');
    },

    iosEnd(swk) { this[swk].mode = 'exec'; this[swk].currentIf = null; return createStdout(''); },

    iosInterface(swk, x) {
      const s = this[swk];
      const validModes = ['config', 'config-if', 'config-if-range'];
      if (!validModes.includes(s.mode)) return createStderr('% Invalid input detected — must be in configuration mode');

      const sub1 = (x._[1] || '').toLowerCase();

      if (sub1 === 'range') {
        s.mode = 'config-if-range';
        s.currentIf = 'range';
        const c = this[swk + 'Completion'];
        if (!c.rangeEntered) { c.rangeEntered = true; this.updateScore(); }
        return createStdout(this.guide(
          `${this.swkLabel(swk)}: entered interface range configuration for e0/0 and e0/1 simultaneously. ` +
          'Commands typed here apply to both ports at once. Note: in Packet Tracer, e0/0 is replaced by fa0/10. ' +
          '→ "switchport trunk encapsulation dot1q" to select 802.1Q tagging.'
        ));
      }

      // Single interface (e.g., interface po15, interface e0/0)
      let ifArg = String(x._[1] || '');
      const ifNorm = this.normalizeIf(ifArg) || ifArg.toLowerCase();
      s.mode = 'config-if';
      s.currentIf = ifNorm;
      return createStdout('');
    },

    iosSwitchport(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-if' && s.mode !== 'config-if-range') {
        return createStderr('% Invalid input detected — must be in interface configuration mode');
      }
      const c    = this[swk + 'Completion'];
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();
      const sub3 = (x._[3] || '').toLowerCase();
      const swName = this.swkLabel(swk);

      // switchport trunk encapsulation dot1q
      if (sub1 === 'trunk' && sub2 === 'encapsulation' && sub3 === 'dot1q') {
        if (!c.trunkEncap) {
          c.trunkEncap = true; this.updateScore();
          return createStdout(this.guide(
            '802.1Q encapsulation set on both trunk ports. 802.1Q (IEEE standard) inserts a 4-byte tag into the frame header — required on switches that support both ISL and dot1q. ' +
            '→ "switchport mode trunk".'
          ));
        }
        return createStdout('');
      }

      // switchport mode trunk
      if (sub1 === 'mode' && sub2 === 'trunk') {
        if (!c.trunkMode) {
          c.trunkMode = true; this.updateScore();
          return createStdout(this.guide(
            `${swName} e0/0 and e0/1 set to trunk mode. Trunk ports carry multiple VLANs — by default all VLANs are allowed. ` +
            'The next commands restrict and tune VLAN behavior. → "switchport trunk native vlan 45".'
          ));
        }
        return createStdout('');
      }

      // switchport trunk native vlan 45
      if (sub1 === 'trunk' && sub2 === 'native' && sub3 === 'vlan') {
        const vlanId = String(x._[4] || '');
        if (vlanId === '45' && !c.trunkNative) {
          c.trunkNative = true; this.updateScore();
          return createStdout(this.guide(
            'Native VLAN set to 45 on both trunk ports. Untagged frames received on a trunk are assigned to the native VLAN — VLAN 45 traffic crosses the trunk without 802.1Q tags. ' +
            'Both ends of the trunk MUST share the same native VLAN or frames are silently misassigned. ' +
            '→ "switchport trunk allowed vlan 15,45".'
          ));
        }
        return createStdout('');
      }

      // switchport trunk allowed vlan <list>
      if (sub1 === 'trunk' && sub2 === 'allowed' && sub3 === 'vlan') {
        const vlanList = x._.slice(4).join('').replace(/\s/g, '');
        if ((vlanList === '15,45' || vlanList === '45,15') && !c.trunkAllowed) {
          c.trunkAllowed = true; this.updateScore();
          const other = swk === 'sw1' ? 'Sw2' : 'Sw1';
          return createStdout(this.guide(
            `${swName} trunk restricted to VLANs 15 (tagged) and 45 (native/untagged). ` +
            'Limiting allowed VLANs reduces the broadcast domain and prevents VLAN leakage across the trunk. ' +
            (this.getComp(swk === 'sw1' ? 'sw2' : 'sw1').trunkAllowed
              ? '→ Both switches configured. Task 2: type "channel-group 15 mode active" to enable LACP.'
              : `→ Configure the same trunk on ${other}.`)
          ));
        }
        return createStdout('');
      }

      return createStderr('% Invalid input detected');
    },

    iosChannelGroup(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-if' && s.mode !== 'config-if-range') {
        return createStderr('% Invalid input detected — must be in interface configuration mode');
      }
      const groupNum = String(x._[1] || '');
      const modeKw   = (x._[2] || '').toLowerCase();
      const modeVal  = (x._[3] || '').toLowerCase();
      const c        = this[swk + 'Completion'];

      if (groupNum === '15' && modeKw === 'mode' && modeVal === 'active' && !c.channelGroup) {
        c.channelGroup = true; this.updateScore();
        return createStdout(this.guide(
          `Port-Channel 15 created with LACP 'active' mode on ${this.swkLabel(swk)}. ` +
          'Active mode means this switch actively initiates LACP negotiation — it sends LACP PDUs and waits for a matching peer. ' +
          'Both switches running active mode is valid: together they negotiate and bundle E0/0 + E0/1 into a single logical link (Po15) with double the bandwidth and automatic failover. ' +
          'Note: Packet Tracer may show a CANNOT_BUNDLE2 error — this is a PT simulator limitation that does not occur on real hardware or EVE-NG. ' +
          (this.getComp(swk === 'sw1' ? 'sw2' : 'sw1').channelGroup
            ? '→ Save both switches: "end" then "copy running-config startup-config".'
            : `→ Configure the same on ${swk === 'sw1' ? 'Sw2' : 'Sw1'}.`)
        ));
      }
      return createStdout('');
    },

    iosCopy(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const c = this[swk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout(
          'Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(
            `${this.swkLabel(swk)} configuration saved to NVRAM. ` +
            (this.saveDone ? '✓ Both switches saved — simulation complete!' : '→ Save the remaining switch.')
          )
        );
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#sw1_terminal, #sw2_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

